module.exports = __webpack_public_path__ + "static/media/branding_1080p_tc.090419bd.png";